import { render, staticRenderFns } from "./AccountFeed.vue?vue&type=template&id=32d3b53a&scoped=true&"
import script from "./AccountFeed.vue?vue&type=script&lang=ts&"
export * from "./AccountFeed.vue?vue&type=script&lang=ts&"
import style0 from "./AccountFeed.vue?vue&type=style&index=0&id=32d3b53a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d3b53a",
  null
  
)

export default component.exports